import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function ADACompliant() {
  const lastUpdated = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#fffcf0' }}>
      <Navbar />
      <main className="flex-1 max-w-3xl mx-auto px-4 md:px-8 pt-40 md:pt-44 pb-16 md:pb-24 w-full">
        <Link
          to="/"
          className="inline-block mb-8 text-sm font-medium transition-colors hover:opacity-70"
          style={{ fontFamily: "'Poppins', sans-serif", color: '#ff7a59' }}
        >
          ← Back to Home
        </Link>
        <h1
          className="text-3xl md:text-4xl font-bold mb-4 text-gray-700"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          Accessibility Statement
        </h1>
        <p
          className="text-sm mb-10 text-gray-600"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          Last updated: {lastUpdated}
        </p>

        <div className="space-y-8" style={{ fontFamily: "'Poppins', sans-serif", color: '#292929' }}>
          <p>
            For visitors with special needs, we will gladly provide any assistance we can to
            accommodate your needs.
          </p>
          <p>
            WebaNova is committed to making this website accessible to all users, including people
            with disabilities. We aim to follow accessibility best practices and continuously
            improve the user experience for everyone.
          </p>

          <section>
            <h2 className="text-xl font-bold mb-3 text-gray-700">Our Accessibility Commitment</h2>
            <p>
              We work to support accessibility standards such as the Web Content Accessibility
              Guidelines (WCAG) and to provide a site experience that is perceivable, operable,
              understandable, and robust across devices and assistive technologies.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3 text-gray-700">Accessibility Tools</h2>
            <p>
              This site includes an accessibility toolbar (the blue button in the corner of the
              page) so you can adjust contrast, text size, spacing, motion, and other settings to
              fit your needs. Your preferences are saved in your browser.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3 text-gray-700">Ongoing Improvements</h2>
            <p>
              Accessibility is an ongoing effort. We regularly review content and functionality and
              make updates as we identify opportunities to improve accessibility.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3 text-gray-700">Need Help Accessing Something?</h2>
            <p>
              If you experience difficulty accessing any part of this website, please{' '}
              <Link to="/contactme" className="font-semibold" style={{ color: '#ff7a59' }}>
                contact us
              </Link>{' '}
              or call{' '}
              <a href="tel:+18186419709" className="font-semibold" style={{ color: '#ff7a59' }}>
                (818) 641-9709
              </a>
              .
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
